<template lang="jade">
  component(":is"="fdata.actions[0]"
            ":fdata.sync"="fdata")
</template>

<script>
  /* eslint-disable no-multi-spaces */
  import buttons from './_sub/index'

  export default{
    data () {
      return {
        uid: this.$parent.uid
      }
    },
    props: ['fdata'],
    components: buttons
    // attached () {
    //   let evt = new CustomEvent('attached', { detail: 'Components attached to DOM',
    //                                           bubbles: true,
    //                                           cancelable: false })
    //   document.dispatchEvent(evt)
    // },
    // beforeDestroy () {
    //   let evt = new CustomEvent('destroy', { detail: 'Components removed from DOM',
    //                                           bubbles: true,
    //                                           cancelable: false })
    //   document.dispatchEvent(evt)
    // }
  }
</script>



// WEBPACK FOOTER //
// button.vue?115da520